export default __webpack_public_path__ + "static/women-bodymap-bikini-area-7d6472676d961bab03a4a756bc8f321c.webp";